module.exports = __webpack_public_path__ + "static/img/4.883182e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/eng/4.png
// module id = k1Ej
// module chunks = 0